var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        "close-on-click-modal": false,
        "show-close": true,
        title: _vm.$t("placeOrder.BatchExport"),
        visible: _vm.dialogVisibleExport,
        top: "10vh",
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibleExport = $event
        },
        close: _vm.clearForm,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "exportRuleForm",
          staticClass: "demo-exportRuleForm",
          attrs: { model: _vm.exportRuleForm, "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                rules: {
                  required: true,
                  message: _vm.$t("placeOrder.pleaseInput"),
                  trigger: ["blur", "change"],
                },
                prop: "NumberType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "80%" },
                  on: { change: _vm.handleNumberTypeChange },
                  model: {
                    value: _vm.exportRuleForm.NumberType,
                    callback: function ($$v) {
                      _vm.$set(_vm.exportRuleForm, "NumberType", $$v)
                    },
                    expression: "exportRuleForm.NumberType",
                  },
                },
                [
                  _c("el-option", {
                    key: "1",
                    attrs: {
                      label: _vm.$t("orderCenterCont.anjunWaybillNumber"),
                      value: 1,
                    },
                  }),
                  _c("el-option", {
                    key: "6",
                    attrs: {
                      label: _vm.$t("GlobalSetObj.ScanNumber"),
                      value: 6,
                    },
                  }),
                  _c("el-option", {
                    key: "2",
                    attrs: {
                      label: _vm.$t("GlobalSetObj.serviceLogistics"),
                      value: 2,
                    },
                  }),
                  _c("el-option", {
                    key: "3",
                    attrs: {
                      label: _vm.$t("newOrder.PlatformOrderNumber"),
                      value: 3,
                    },
                  }),
                  _c("el-option", {
                    key: "4",
                    attrs: {
                      label: _vm.$t("orderCenterCont.TransitBinBagNumber"),
                      value: 4,
                    },
                  }),
                  _c("el-option", {
                    key: "5",
                    attrs: {
                      label: _vm.$t("orderCenterCont.SubpackageNumber"),
                      value: 5,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: {
                rules: {
                  required: true,
                  message: _vm.$t("placeOrder.pleaseInput"),
                  trigger: ["blur"],
                },
                prop: "inputValeu",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("orderCenterCont.Multiple"),
                  clearable: "",
                  rows: "6",
                  type: "textarea",
                },
                model: {
                  value: _vm.exportRuleForm.inputValeu,
                  callback: function ($$v) {
                    _vm.$set(_vm.exportRuleForm, "inputValeu", $$v)
                  },
                  expression: "exportRuleForm.inputValeu",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-radio",
            {
              attrs: { label: "1" },
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.ExportingList")))]
          ),
          _c(
            "el-radio",
            {
              attrs: { label: "2" },
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.ExportReceipt")))]
          ),
          _c(
            "el-radio",
            {
              attrs: { label: "3" },
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.ExportSubPackage")))]
          ),
          _c(
            "el-radio",
            {
              attrs: {
                disabled: _vm.secondLatestTrackRadioDisabled,
                label: "4",
              },
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("GlobalSetObj.ExportSecondLatestTrack")) +
                  " "
              ),
            ]
          ),
          _c(
            "el-radio",
            {
              attrs: { label: "5" },
              model: {
                value: _vm.radio,
                callback: function ($$v) {
                  _vm.radio = $$v
                },
                expression: "radio",
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("GlobalSetObj.crossBorderInvoiceInfo")) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "15px 0" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.dialogVisibleExport = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.comfire },
            },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.CheckItOutNow")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }